import { ConfirmationModal } from "@/imports-files/components/common-modal/common-modal";
import InfoModal from "./infoModal/infoModal";
import FormModal from "./form-modal/form-modal";

const Modal = (props) => {
  const { type, className } = props;
  switch (type) {
    case "confirmation":
      return <ConfirmationModal {...props} className={className} />;
    case "info":
      return <InfoModal {...props} className={className} />;
    case "form":
      return <FormModal {...props} className={className} />;
  }
};

export default Modal;
